import React, { useEffect, useRef } from "react";
import { ImageWithFocalPointType } from "@swo/shared";
import cn from "classnames";

import { css } from "@emotion/react";
import { BREAKPOINTS, CSS_MQ } from "../../../styles/breakpoints";
import { HeroImageComponentType } from "@swo/storefront";
import {
  centeredFocalPoint,
  FocalPointPosition,
  getFocalPoint,
} from "../../_shared-components/image-related/ImageWithFocalPoint";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { pipe } from "fp-ts/lib/function";
import { option } from "fp-ts";
import { ImageSourceElements } from "./ImageSourceElements";
import { createFallbackImage, createJpgLink } from "../../_shared-components/image-related/createJpgAndWebpLinks";
import { useCurrentWidth } from "../../../hooks/use-current-width";
import { VideoType } from "@swo/shared";
import { PictureHeroImageVisualElement } from "./PictureHeroImageVisualElement";
import { VideoHeroImageVisualElement } from "./VideoHeroImageVisualElement";

export const HeroImageVisualElement: React.FC<{
  desktopVisualAsset: HeroImageComponentType["desktopVisualAsset"];
  mobileVisualAsset: HeroImageComponentType["mobileVisualAsset"];
}> = props => {
  function getFallbackMobileValue(): HeroImageComponentType["desktopVisualAsset"] {
    if (typeof props.mobileVisualAsset === "undefined") {
      return props.desktopVisualAsset;
    } else {
      return props.mobileVisualAsset;
    }
  }

  const mobileVisualAssetWithFallback = getFallbackMobileValue();

  return (
    <React.Fragment>
      <PictureHeroImageVisualElement
        mobile={getImageOrUndefined(mobileVisualAssetWithFallback)}
        desktop={getImageOrUndefined(props.desktopVisualAsset)}
      />
      <VideoHeroImageVisualElement
        mobile={getVideoOrUndefined(mobileVisualAssetWithFallback)}
        desktop={getVideoOrUndefined(props.desktopVisualAsset)}
      />
    </React.Fragment>
  );
};

function getImageOrUndefined(asset: ImageWithFocalPointType | VideoType): ImageWithFocalPointType | undefined {
  return asset.__typename === "UtilityImageWithFocalPoint" ? asset : undefined;
}

function getVideoOrUndefined(asset: ImageWithFocalPointType | VideoType): VideoType | undefined {
  return asset.__typename === "UtilityVideo" ? asset : undefined;
}
